module.exports = __webpack_public_path__ + "img/030.bfc15eda.jpg";